module.exports = {
  'EPISTAXIS_SMALL': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'NOSE'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NOSE'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NOSE'
      ]
    }
  },
  'EPISTAXIS_MEDIUM': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'NOSE'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NOSE'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NOSE'
      ]
    }
  },
  'EPISTAXIS_LARGE': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'NOSE'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NOSE'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NOSE'
      ]
    }
  },
  'BLEEDING_SMALL': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'MOUTH'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'MOUTH'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'MOUTH'
      ]
    }
  },
  'BLEEDING_MEDIUM': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'MOUTH'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'MOUTH'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'MOUTH'
      ]
    }
  },
  'ABRASION_MODERATE_MEDIUM': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'ABRASION_MODERATE_LARGE': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'ABRASION_MODERATE_SMALL': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'NECK',
        'HEAD'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NECK',
        'CHEST'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NECK',
        'CHEST'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'CHEST'
      ]
    }
  },
  'ABRASION_SEVERE_MEDIUM': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'ABRASION_SEVERE_LARGE': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AVULSION_SKIN_TEAR_MEDIUM': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AVULSION_NOSE': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    }
  },
  'AVULSION_EAR': {
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'NOSE',
        'EARS'
      ]
    }
  },
  'DEGLOVING': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_GAUZE_MITTEN_WRAP': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    }
  },
  'DEGLOVING_DIGITS': {
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'BANDAGE_GAUZE_MITTEN_WRAP': {
      'triggeringLocations': [
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    }
  },
  'FRACTURE_CLOSED_LOWER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'PADDED_BOARD_SPLINT_FULL_LEG': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'PADDED_BOARD_SPLINT_FULL_ARM': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
      ]
    },
    'PADDED_BOARD_SPLINT_WRAP_SHORT': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'MANUAL_STABILIZATION': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'HARE_TRACTION_SPLINT': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'SAGER_TRACTION_SPLINT': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    }
  },
  'FRACTURE_CLOSED_UPPER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'PADDED_BOARD_SPLINT_FULL_LEG': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'PADDED_BOARD_SPLINT_FULL_ARM': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'PADDED_BOARD_SPLINT_WRAP_SHORT': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'MANUAL_STABILIZATION': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'HARE_TRACTION_SPLINT': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'SAGER_TRACTION_SPLINT': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    }
  },
  'FRACTURE_CLOSED_EXTREMITY': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'PADDED_BOARD_SPLINT_FULL_LEG': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'PADDED_BOARD_SPLINT_FULL_ARM': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
      ]
    },
    'PADDED_BOARD_SPLINT_WRAP_SHORT': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'MANUAL_STABILIZATION': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'HARE_TRACTION_SPLINT': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'SAGER_TRACTION_SPLINT': {
      'triggeringLocations': [
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    }
  },
  'GSW_ENTRY_SMALL': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    }
  },
  'GSW_ENTRY_MEDIUM': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    }
  },
  'GSW_ENTRY_AND_EXIT_SMALL': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT',
        'LEFT_HAND',
        'RIGHT_HAND'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    }
  },
  'GSW_ENTRY_AND_EXIT_MEDIUM': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'SLING_SWATHE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    },
    'SLING': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER'
      ]
    }
  },
  'GSW_MULTIPLE_SMALL': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    }
  },
  'GSW_MULTIPLE_MEDIUM': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    }
  },
  'STABBING_SMALL': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'STABBING_BRUISED_SMALL': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'STABBING_MEDIUM': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'STABBING_BRUISED_MEDIUM': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'STABBING_SMALL_CLUSTER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'PETROLEUM_GAUZE': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'CHEST_SEAL': {
      'triggeringLocations': [
        'CHEST'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'ABDOMEN',
        'BACK_UPPER',
        'BACK_LOWER'
      ]
    }
  },
  'AMPUTATION_CLEAN_UPPER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_CLEAN_LOWER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_CLEAN_EXTREMITY': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_MESSY_UPPER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_MESSY_LOWER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_MESSY_EXTREMITY': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_BLAST_UPPER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_BLAST_LOWER': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'AMPUTATION_BLAST_EXTREMITY': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'LACERATION_SMALL': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'LACERATION_SMALL_2': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NECK'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NECK'
      ]
    }
  },
  'LACERATION_MEDIUM': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'LACERATION_MEDIUM_2': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NECK'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NECK'
      ]
    }
  },
  'LACERATION_LARGE': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'FACE',
        'NECK',
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    },
    'TOURNIQUET_SINGLE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER'
      ]
    }
  },
  'LACERATION_LARGE_2': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'CERVICAL_COLLAR': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'DIRECT_PRESSURE': {
      'triggeringLocations': [
        'HEAD',
        'NECK'
      ]
    },
    'BANDAGE_ROLLER_GAUZE': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'BANDAGE_ELASTIC': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'BANDAGE_PRESSURE': {
      'triggeringLocations': [
        'HEAD'
      ]
    },
    'DRESSING_2X2': {
      'triggeringLocations': [
        'NECK'
      ]
    },
    'DRESSING_4X4': {
      'triggeringLocations': [
        'NECK'
      ]
    }
  },
  'BURN_2ND_DEGREE_LARGE': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_DRY_STERILE_GAUZE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'BURN_3RD_DEGREE_LARGE': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    },
    'BANDAGE_DRY_STERILE_GAUZE': {
      'triggeringLocations': [
        'CHEST',
        'ABDOMEN',
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'BACK_UPPER',
        'BACK_LOWER',
        'GENITALIA',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT',
        'RIGHT_FOOT'
      ]
    }
  },
  'BURN_4TH_DEGREE_LARGE': {
    'LONG_SPINE_BOARD': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT'
      ]
    },
    'BANDAGE_DRY_STERILE_GAUZE': {
      'triggeringLocations': [
        'LEFT_ARM_UPPER',
        'RIGHT_ARM_UPPER',
        'LEFT_ARM_LOWER',
        'RIGHT_ARM_LOWER',
        'LEFT_HAND',
        'RIGHT_HAND',
        'LEFT_LEG_UPPER',
        'RIGHT_LEG_UPPER',
        'LEFT_LEG_LOWER',
        'RIGHT_LEG_LOWER',
        'LEFT_FOOT'
      ]
    }
  }
}
